import React from 'react';
import './Home.css';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Home from "./Home";
import Disclaimer from "./Disclaimer";
import Hint from "./Hint";
import Loading from "./Loading";

// SEMESTER 1
import MATH151 from "./Components/Term1/MATH151";
import CE from "./Components/Electives/CE";
import PHYS140 from "./Components/Term1/PHYS140";
import CHEM120 from "./Components/Term1/CHEM120";
import MSE100 from "./Components/Term1/MSE100";
import CMPT130 from "./Components/Term1/CMPT130";

// SEMESTER 2
import MATH152 from "./Components/Term2/MATH152";
import MATH232 from "./Components/Term2/MATH232";
import PHYS141 from "./Components/Term2/PHYS141";
import MSE101W from "./Components/Term2/MSE101W";
import MSE102 from "./Components/Term2/MSE102";
import MSE110 from "./Components/Term2/MSE110";

// SEMESTER 4
import MATH251 from "./Components/Term4/MATH251";
import MATH260 from "./Components/Term4/MATH260";
import MSE220 from "./Components/Term4/MSE220";
import MSE221 from "./Components/Term4/MSE221";
import MSE250 from "./Components/Term4/MSE250";

// SEMESTER 5
import MSE211 from "./Components/Term5/MSE211";
import MSE210 from "./Components/Term5/MSE210";
import MSE222 from "./Components/Term5/MSE222";
import MSE223 from "./Components/Term5/MSE223";
import MSE251 from "./Components/Term5/MSE251";
import MSE280 from "./Components/Term5/MSE280";

// SEMESTER 7
import MSE310 from "./Components/Term7/MSE310";
import MSE320 from "./Components/Term7/MSE320";
import MSE321 from "./Components/Term7/MSE321";
import MSE352 from "./Components/Term7/MSE352";
import MSE380 from "./Components/Term7/MSE380";

// SEMESTER 9
import MSE300 from "./Components/Term9/MSE300";
import MSE311 from "./Components/Term9/MSE311";
import MSE312 from "./Components/Term9/MSE312";
import MSE353 from "./Components/Term9/MSE353";
import MSE381 from "./Components/Term9/MSE381";

// SEMESTER 11
import MSE402 from "./Components/Term11/MSE402";
import MSE410 from "./Components/Term11/MSE410";
import ENGELEC from "./Components/Electives/ENGELEC";

// SEMESTER 12
import MSE405W from "./Components/Term12/MSE405W";
import MSE411 from "./Components/Term12/MSE411";

// ENGINEERING ELECTIVES ROW 1
import MSE420 from "./Components/Electives/MSE420";
import MSE421 from "./Components/Electives/MSE421";
import MSE422 from "./Components/Electives/MSE422";
import MSE423 from "./Components/Electives/MSE423";
import MSE424 from "./Components/Electives/MSE424";

// ENGINEERING ELECTIVES ROW 2
import MSE425 from "./Components/Electives/MSE425";
import MSE426 from "./Components/Electives/MSE426";
import MSE427 from "./Components/Electives/MSE427";
import MSE428 from "./Components/Electives/MSE428";
import MSE429 from "./Components/Electives/MSE429";

// ENGINEERING ELECTIVES ROW 3
import MSE450 from "./Components/Electives/MSE450";
import MSE451 from "./Components/Electives/MSE451";
import MSE452 from "./Components/Electives/MSE452";
import MSE480 from "./Components/Electives/MSE480";
import MSE481 from "./Components/Electives/MSE481";

// ENGINEERING ELECTIVES ROW 4
import MSE483 from "./Components/Electives/MSE483";
import MSE490 from "./Components/Electives/MSE490";
import MSE491 from "./Components/Electives/MSE491";
import MSE492 from "./Components/Electives/MSE492";

function App() {
  return (
    // alert("You may need to adjust your zoom settings in your screen for optimal viewing"),
    <Router>
      <div>
        <Switch>

          {/* SEMESTER 1 */}
          <Route path="/MATH151" component={MATH151} />
          <Route path="/CE" component={CE} />
          <Route path="/PHYS140" component={PHYS140} />
          <Route path="/CHEM120" component={CHEM120} />
          <Route path="/MSE100" component={MSE100} />
          <Route path="/CMPT130" component={CMPT130} />

          {/* SEMESTER 2 */}
          <Route path="/MATH152" component={MATH152} />
          <Route path="/MATH232" component={MATH232} />
          <Route path="/PHYS141" component={PHYS141} />
          <Route path="/MSE101W" component={MSE101W} />
          <Route path="/MSE102" component={MSE102} />
          <Route path="/MSE110" component={MSE110} />

          {/* SEMESTER 4 */}
          <Route path="/MATH251" component={MATH251} />
          <Route path="/MATH260" component={MATH260} />
          <Route path="/MSE220" component={MSE220} />
          <Route path="/MSE221" component={MSE221} />
          <Route path="/MSE250" component={MSE250} />

          {/* SEMESTER 5 */}
          <Route path="/MSE211" component={MSE211} />
          <Route path="/MSE210" component={MSE210} />
          <Route path="/MSE222" component={MSE222} />
          <Route path="/MSE223" component={MSE223} />
          <Route path="/MSE251" component={MSE251} />
          <Route path="/MSE280" component={MSE280} />

          {/* SEMESTER 7 */}
          <Route path="/MSE310" component={MSE310} />
          <Route path="/MSE320" component={MSE320} />
          <Route path="/MSE321" component={MSE321} />
          <Route path="/MSE352" component={MSE352} />
          <Route path="/MSE380" component={MSE380} />

          {/* SEMESTER 9 */}
          <Route path="/MSE300" component={MSE300} />
          <Route path="/MSE311" component={MSE311} />
          <Route path="/MSE312" component={MSE312} />
          <Route path="/MSE353" component={MSE353} />
          <Route path="/MSE381" component={MSE381} />
          
          {/* SEMESTER 11 */}
          <Route path="/MSE402" component={MSE402} />
          <Route path="/MSE410" component={MSE410} />
          <Route path="/ENGELEC" component={ENGELEC} />

          {/* SEMESTER 12 */}
          <Route path="/MSE405W" component={MSE405W} />
          <Route path="/MSE411" component={MSE411} />

          {/* ENGINEERING ELECTIVES ROW 1 */}
          <Route path="/MSE420" component={MSE420} />
          <Route path="/MSE421" component={MSE421} />
          <Route path="/MSE422" component={MSE422} />
          <Route path="/MSE423" component={MSE423} />
          <Route path="/MSE424" component={MSE424} />

          {/* ENGINEERING ELECTIVES ROW 2 */}
          <Route path="/MSE425" component={MSE425} />
          <Route path="/MSE426" component={MSE426} />
          <Route path="/MSE427" component={MSE427} />
          <Route path="/MSE428" component={MSE428} />
          <Route path="/MSE429" component={MSE429} />

          {/* ENGINEERING ELECTIVES ROW 3 */}
          <Route path="/MSE450" component={MSE450} />
          <Route path="/MSE451" component={MSE451} />
          <Route path="/MSE452" component={MSE452} />
          <Route path="/MSE480" component={MSE480} />
          <Route path="/MSE481" component={MSE481} />

          {/* ENGINEERING ELECTIVES ROW 4 */}
          <Route path="/MSE483" component={MSE483} />
          <Route path="/MSE490" component={MSE490} />
          <Route path="/MSE491" component={MSE491} />
          <Route path="/MSE492" component={MSE492} />

          <Route path="/RaWRxD" component={Hint} />
          <Route path="/DexterBigueta" exact component={Loading} />

          <Route path="/Home" component={Home} />
        
          <Route path="/" exact component={Disclaimer} />
        </Switch>
      </div>
    </Router> 
  );
}

export default App;